import { render, staticRenderFns } from "./Clinician.vue?vue&type=template&id=ccccd4b2&"
import script from "./Clinician.vue?vue&type=script&lang=js&"
export * from "./Clinician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports